<template>
    <div class="border rounded-xl w-full p-[16px] flex justify-between items-center font-light">
        <div>
            <h2>{{ zone.label }}</h2>
        </div>

        <button :disabled="load" @click="enableOrDisable(containPerm(zone.users,userId))" :class="['h-[35px] font-light px-4 border rounded-xl flex items-center justify-center',{'bg-[#5357eb] text-white border-[#5357eb]':containPerm(zone.users,userId)}]">
            <Loader2 v-if="load" class="animate-spin mx-auto"/>
            <span v-if="!load">{{ containPerm(zone.users,userId) ? "Interdir" : "Autoriser"}}</span>
        </button>
    </div>
</template>
<script>
import API from '@/service/API';
import Swal from 'sweetalert2';
import { Loader2 } from 'lucide-vue-next';
export default {
    name: "AutoriseZone",
    components:{Loader2},
    props: ["zone","userId"],
    data(){
        return {
            load: false
        }
    },
    methods:{
        enableOrDisable(value){
            this.load = true;
            API.post((value ? "dissociateUserToZone/" : "associateUserToZone/")+this.zone.id,{"user_id": this.userId})
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message)
                this.$emit('child-action');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=> this.load = false)
        },
        containPerm(tab,id){
            let match = false;
            for (const element of tab) {
                if(element.id == id){
                    match = true;
                    break;
                }
            }
            return match;
        }
    }
}
</script>